import { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { GraduationCap, LogOut, Settings } from 'lucide-react';
import { useAuthStore } from '@store/auth';
import { useSignOut } from '@features/auth';
import { bashHarfler, cn } from '@lib/utils';

export function UserMenu() {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  const me = useAuthStore((s) => s.me);
  const signOut = useSignOut();

  useEffect(() => {
    const handler = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  if (!me) return null;

  return (
    <div ref={ref} className="relative">
      <button
        onClick={() => setOpen((v) => !v)}
        className="flex items-center gap-2 rounded-md px-2 py-1 hover:bg-muted transition-colors"
        aria-label="Kullanıcı menüsü"
      >
        <div className="flex h-8 w-8 items-center justify-center rounded-full bg-primary/10 text-sm font-medium text-primary">
          {bashHarfler(me.ad, me.soyad)}
        </div>
        <div className="hidden text-left lg:block">
          <div className="text-sm font-medium">{me.ad} {me.soyad}</div>
          <div className="text-xs text-muted-foreground">{me.tenantAdi}</div>
        </div>
      </button>

      {open && (
        <div
          className={cn(
            'absolute right-0 mt-2 w-56 rounded-lg border bg-card shadow-lg z-50',
            'animate-fade-in',
          )}
        >
          <div className="border-b p-3">
            <div className="text-sm font-medium">{me.ad} {me.soyad}</div>
            <div className="text-xs text-muted-foreground truncate">{me.email}</div>
          </div>
          <nav className="p-1">
            <Link
              to="/ayarlar"
              onClick={() => setOpen(false)}
              className="flex w-full items-center gap-2 rounded-md px-3 py-2 text-sm hover:bg-muted transition-colors"
            >
              <Settings className="h-4 w-4" />
              Ayarlar
            </Link>
            <Link
              to="/egitim"
              onClick={() => setOpen(false)}
              className="flex w-full items-center gap-2 rounded-md px-3 py-2 text-sm hover:bg-muted transition-colors"
            >
              <GraduationCap className="h-4 w-4" />
              Eğitim Videoları
            </Link>
            <button
              onClick={() => signOut.mutate()}
              disabled={signOut.isPending}
              className="flex w-full items-center gap-2 rounded-md px-3 py-2 text-sm text-danger hover:bg-danger/10 transition-colors disabled:opacity-50"
            >
              <LogOut className="h-4 w-4" />
              {signOut.isPending ? 'Çıkış yapılıyor...' : 'Çıkış Yap'}
            </button>
          </nav>
        </div>
      )}
    </div>
  );
}
